import { lookupType } from "../lib/aircraftTypes.js";
import "./TypeInfo.css";

export default function TypeInfo({ typeCode, model, manufacturer }) {
  const info = lookupType(typeCode);

  if (info) {
    return (
      <div className="type-info" aria-label={`About the ${info.name}`}>
        <h3 className="type-info-name">{info.name}</h3>
        <p className="type-info-meta">
          <span>{info.category}</span>
          <span className="type-info-dot">·</span>
          <span>{info.engines}</span>
          <span className="type-info-dot">·</span>
          <span>{info.typicalSeats} seats</span>
        </p>
        <p className="type-info-blurb">{info.blurb}</p>
      </div>
    );
  }

  const fallback = [manufacturer, model].filter(Boolean).join(" ");
  if (fallback) {
    return (
      <div className="type-info" aria-label={`About the ${fallback}`}>
        <h3 className="type-info-name">{fallback}</h3>
        <p className="type-info-meta muted">Aircraft type</p>
      </div>
    );
  }

  return null;
}
